import { storeOnboardingResponsesWithSavedAnswers } from '@eventbrite/creator-onboarding-api';
import type { AsyncActionOptions } from '../types';

export const saveOnboardingResponses = async ({
    organizationId,
    publicId,
    options,
}: {
    organizationId: string;
    publicId: string;
    options?: AsyncActionOptions;
}) => {
    if (options?.testingFlags.shouldError) {
        await new Promise((resolve) => setTimeout(resolve, 1700));
        throw new Error('Error saving onboarding responses');
    }

    await storeOnboardingResponsesWithSavedAnswers(publicId, organizationId);
};
